/**
 * Internal dependencies
 */
import { PREFIX_EVENTS_STORE } from '@moderntribe/events/data/utils';

export const SET_START_DATE_TIME = `${ PREFIX_EVENTS_STORE }/SET_START_DATE_TIME`;
export const SET_END_DATE_TIME = `${ PREFIX_EVENTS_STORE }/SET_END_DATE_TIME`;

export const SET_NATURAL_LANGUAGE_LABEL = `${ PREFIX_EVENTS_STORE }/SET_NATURAL_LANGUAGE_LABEL`;

export const SET_MULTI_DAY = `${ PREFIX_EVENTS_STORE }/SET_MULTI_DAY`;

export const SET_ALL_DAY = `${ PREFIX_EVENTS_STORE }/SET_ALL_DAY`;

export const SET_SEPARATOR_DATE = `${ PREFIX_EVENTS_STORE }/SET_SEPARATOR_DATE`;
export const SET_SEPARATOR_TIME = `${ PREFIX_EVENTS_STORE }/SET_SEPARATOR_TIME`;

export const SET_TIME_ZONE = `${ PREFIX_EVENTS_STORE }/SET_TIME_ZONE`;
export const SET_TIMEZONE_VISIBILITY = `${ PREFIX_EVENTS_STORE }/SET_TIMEZONE_VISIBILITY`;
export const SET_TIMEZONE_LABEL = `${ PREFIX_EVENTS_STORE }/SET_TIMEZONE_LABEL`;

export const SET_DATE_INPUT_VISIBILITY = `${ PREFIX_EVENTS_STORE }/SET_DATE_INPUT_VISIBILITY`;

export const SET_DATETIME_BLOCK_EDITABLE_STATE = `${ PREFIX_EVENTS_STORE }/SET_DATETIME_BLOCK_EDITABLE_STATE`;
